import {
    REPORTS_FIRST_SERVICE,
    REPORTS_SERVICE,
    FOLLOWUP_SERVICE,
    FIRST_EEG_SERVICE,
    GENERAL_EEG_SERVICE,
    PARENTAL_COUNSELLING_SERVICE,
} from "../../utils/constants";

export const SERVICE_CATEGORY_ID_MAPPING: Record<string, number> = {
    evaluations_first: FIRST_EEG_SERVICE,
    evaluations_others: GENERAL_EEG_SERVICE,
    reports_first: REPORTS_FIRST_SERVICE,
    reports_others: REPORTS_SERVICE,
    followup: FOLLOWUP_SERVICE,
    parental_counselling: PARENTAL_COUNSELLING_SERVICE,
};
